(function() {
  function toNumber(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? fallback : parsed;
  }

  function getSections() {
    return Array.from(
      document.querySelectorAll('.featured-collections[data-section-type="featured-collections"]')
    );
  }

  function initOrDestroyCarousel(section) {
    var tabletBreakpoint = toNumber(section.dataset.breakpointTablet, 800);
    var mobileBreakpoint = toNumber(section.dataset.breakpointMobile, 600);
    var autoplayMobile = section.dataset.autoplayMobile === 'true';
    var autoplaySpeed = toNumber(section.dataset.autoplaySpeed, 3000);
    var carousels = section.querySelectorAll('.carousel');

    if (window.innerWidth < tabletBreakpoint) {
      carousels.forEach(function(carousel) {
        if (!$(carousel).hasClass('slick-initialized')) {
          $(carousel).slick({
            autoplay: false,
            autoplaySpeed: autoplaySpeed,
            speed: 200,
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: false,
            centerMode: true,
            centerPadding: '1.5em',
            responsive: [
              {
                breakpoint: mobileBreakpoint,
                settings: {
                  autoplay: autoplayMobile,
                  slidesToShow: 2,
                  slidesToScroll: 2
                }
              }
            ]
          });
          $(carousel).slick('setPosition');
        }
      });
    } else {
      carousels.forEach(function(carousel) {
        if ($(carousel).hasClass('slick-initialized')) {
          $(carousel).slick('unslick');
        }
      });
    }
  }

  function whenSlickReady(callback, attempt) {
    var currentAttempt = attempt || 0;
    if (window.jQuery && $.fn && typeof $.fn.slick === 'function') {
      callback();
      return;
    }

    if (currentAttempt > 40) return;
    setTimeout(function() {
      whenSlickReady(callback, currentAttempt + 1);
    }, 150);
  }

  $(function() {
    whenSlickReady(function() {
      var run = function() {
        getSections().forEach(initOrDestroyCarousel);
      };

      run();
      $(window).on('load', run);
      if ($.throttle) {
        $(window).resize($.throttle(15, run));
      } else {
        $(window).on('resize', run);
      }
    });
  });
})();
